var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcBank(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 14,
    viewBox: "0 0 24 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.125 0.5H1.875C1.24219 0.5 0.75 1.02734 0.75 1.625V12.875C0.75 13.5078 1.24219 14 1.875 14H22.125C22.7227 14 23.25 13.5078 23.25 12.875V1.625C23.25 1.02734 22.7227 0.5 22.125 0.5ZM21.5625 10.0625C20.2969 10.0625 19.3125 11.082 19.3125 12.3125H4.6875C4.6875 11.082 3.66797 10.0625 2.4375 10.0625V4.4375C3.66797 4.4375 4.6875 3.45312 4.6875 2.1875H19.3125C19.3125 3.45312 20.2969 4.4375 21.5625 4.4375V10.0625ZM12 3.875C10.418 3.875 9.1875 5.38672 9.1875 7.25C9.1875 9.14844 10.418 10.625 12 10.625C13.5469 10.625 14.8125 9.14844 14.8125 7.25C14.8125 5.38672 13.5469 3.875 12 3.875Z",
    fill: "#199690"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBank);
export default __webpack_public_path__ + "static/media/ic-bank.29894799b93d0c635e19c03201e38dc0.svg";
export { ForwardRef as ReactComponent };